<template>
    <div class="sub-assignment-edit-header">
        <div
            class="component-title"
            :class="sectionIn && 'order-1 order-sm-0'">
            <h5 class="title">
                {{ sectionIn.title }}
            </h5>
        </div>

        <div class="sub-assignment-edit-tools order-0 order-sm-1">
            <div class="context-nav context-nav-sub-assignment">
                <b-dropdown
                    class="ellipsis-nav sub-assignment-nav"
                    no-caret
                    variant="primary"
                    right
                    toggle-class="sub-assignment-edit-context-menu">
                    <template v-slot:button-content>
                        <i class="fas fa-ellipsis-v"></i>
                    </template>

                    <b-dropdown-item
                        class="edit-sub-assignment-title"
                        v-b-modal="'rating-edit-section-modal' + sectionIn.id"
                        @click="$event.stopPropagation()">
                        <i class="btn-edit"></i>{{ $t('rating.edit_section_name') }}
                    </b-dropdown-item>

                    <b-dropdown-item
                        class="remove-sub-assignment"
                        @click.prevent.stop="onRemove()">
                        <i class="btn-remove"></i>{{ $t('rating.delete_section_title') }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <design-2021-rating-edit-section-title-edit-modal-component
            :section-in="sectionIn"></design-2021-rating-edit-section-title-edit-modal-component>
    </div>
</template>

<script>
import { ords } from '../../app';

export default {
    name: 'design-2021-rating-edit-section-header-component',
    props: ['sectionIn', 'ratingIn'],
    methods: {
        onRemove() {
            this.alert
                .confirm(this.$t('rating.delete_section_title'), this.$t('rating.delete_section_confirmation_body'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving(
                            this.$t('rating.delete_section_title'),
                            this.$t('rating.delete_section_body'),
                        );
                        this.axios.delete(this.routes.ratingSectionDelete(this.sectionIn.id)).then(
                            (response) => {
                                this.ratingIn.detach('sections', this.sectionIn.id);

                                this.sectionIn.remove();
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
.sub-assignment-edit-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .component-title {
        margin-bottom: 0;
        margin-right: map-get($grid-gutter-spacing, 'fifteen');
    }

    .deadline {
        color: $danger;
        font-size: $base-font-size;

        .icon {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }

    .sub-assignment-edit-tools {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        flex: 1 0 100%;
        margin-bottom: map-get($grid-gutter-spacing, 'eight');

        .context-nav-sub-assignment {
            margin-left: auto;
        }
    }
}

.context-nav-sub-assignment ::v-deep {
    .sub-assignment-nav {
        button.dropdown-toggle {
            color: $white !important;
            background-color: var(--primary);
            padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'fifteen');
        }

        .dropdown-menu {
            border: 1px solid $border-color;
        }

        .edit-sub-assignment-title {
            i {
                color: var(--primary);
            }
        }

        .edit-sub-assignment-title,
        .remove-sub-assignment {
            font-size: $default-font-size;

            .dropdown-item {
                display: flex;
                align-items: center;

                i {
                    margin-right: map-get($grid-gutter-spacing, 'eight');
                    font-size: $base-font-size;
                    width: 20px;
                }
            }
        }
    }
}

.organizational-header {
    .component-title {
        width: calc(100% - 51px);
        align-self: center;
    }

    .organizational-tools {
        display: flex;
        align-self: baseline;
        align-items: center;
        margin-left: auto;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .sub-assignment-edit-header {
        .component-title {
            width: calc(100% - 55px);

            .title {
                .deadline {
                    margin-top: map-get($grid-gutter-spacing, 'eight');
                }
            }
        }

        .sub-assignment-edit-tools {
            flex: 0 1 auto;
            margin-bottom: 0;
            align-self: baseline;
        }
    }
}
</style>
